import { getAdminName, getHostId, getStaffFullName, getStaffRole, isAdminSession, loginAdmin, logoutAdmin } from '@/lib/adminAuth'
import type { StaffRole } from '@/types/author'
import { useCallback, useState } from 'react'

export function useAuth() {
  const [loggedIn, setLoggedIn] = useState(() => {
    try {
      return isAdminSession()
    } catch {
      return false
    }
  })
  const [adminName, setAdminName] = useState(() => {
    try {
      return getAdminName()
    } catch {
      return 'Admin'
    }
  })
  const [role, setRole] = useState<StaffRole>(() => {
    try {
      return getStaffRole()
    } catch {
      return 'admin'
    }
  })
  const [fullName, setFullName] = useState(() => {
    try {
      return getStaffFullName()
    } catch {
      return 'Administrador'
    }
  })

  const [hostId, setHostId] = useState(() => {
    try {
      return getHostId()
    } catch {
      return ''
    }
  })

  const login = useCallback(async (username: string, password: string) => {
    const ok = await loginAdmin(username, password)
    setLoggedIn(ok)
    if (ok) {
      setHostId(getHostId())
      setAdminName(getAdminName())
      setRole(getStaffRole())
      setFullName(getStaffFullName())
    }
    return ok
  }, [])

  const logout = useCallback(() => {
    logoutAdmin()
    setLoggedIn(false)
    setAdminName('Admin')
    setRole('admin')
    setFullName('Administrador')
    setHostId('')
  }, [])

  const canEditStation = role === 'admin'
  const isAuthor = role === 'author'
  const isHost = role === 'host'

  return { loggedIn, adminName, fullName, role, hostId, canEditStation, isAuthor, isHost, login, logout }
}
